import {getStore, removeStore, setStore} from "@/utils/storageUtils";
import {
    APP_STORE_KEY_TOKEN, APP_STORE_KEY_USER,
} from "@/config/app.config";

import head_default from "@/assets/images/user-none.png";

export default {
    state: {
        user: getStore(APP_STORE_KEY_USER, "o", {}), token: getStore(APP_STORE_KEY_TOKEN, "s", null),
    }, getters: {
        is_login: (state) => !!state.token, show_user_head: (state) => {
            return state.user ? state.user.member ? state.user.member.avatar ? state.user.member.avatar : head_default : head_default : head_default;
        }, show_user_name: (state) => {
            return state.token ? state.user.member.name || "昵称为空" : "未登录";
        },
        live_open: (state) => {
            return state.user ? state.user.live_open : 0;
        },
        user_id: (state) => {
            return state.user ? state.user.id : null;
        },
        user_level: (state) => {
            return state.user ? state.user.member ? state.user.member.level : 0 : 0;
        },
        is_special: (state) => {
            return state.user ? state.user.member ? state.user.member.is_special : 0 : 0;
        },
    }, mutations: {
        SET_USER(state, user) {
            state.user = user;
            setStore(APP_STORE_KEY_USER, JSON.stringify(user));
        }, SET_TOKEN(state, token) {
            state.token = token;
            setStore(APP_STORE_KEY_TOKEN, token);
        }, CLEAR_USER(state) {
            removeStore(APP_STORE_KEY_USER);
            removeStore(APP_STORE_KEY_TOKEN);
            state.user = null;
            state.token = null;

        },
    }, actions: {
        login: ({commit, dispatch}, payload) => {
            return new Promise((resolve, reject) => {
                HTTP.post("login_admin", payload)
                    .then((resp) => {
                        const {code, data} = resp;
                        if (code !== 0) return reject(resp);
                        commit("SET_USER", data);
                        commit("SET_TOKEN", data.token);
                        dispatch("initAppMenus").then(() => resolve(resp))
                    })
                    .catch(reject);
            });
        }, logout({commit, dispatch}) {
            commit("CLEAR_USER");
            dispatch("initAppMenus");
        },
        refresh: ({commit, dispatch}, payload) => {
            return new Promise((resolve, reject) => {
                HTTP.post("refresh_user", payload)
                    .then((resp) => {
                        const {code, data} = resp;
                        if (code !== 0) return reject(resp);
                        commit("SET_USER", data);
                        dispatch("initAppMenus").then(() => resolve(resp))
                    })
                    .catch(reject);
            });
        }
    },
};
